import { render, staticRenderFns } from "./SimpleTableBuilderModal.vue?vue&type=template&id=72ce11af&scoped=true"
import script from "./SimpleTableBuilderModal.vue?vue&type=script&lang=js"
export * from "./SimpleTableBuilderModal.vue?vue&type=script&lang=js"
import style0 from "./SimpleTableBuilderModal.vue?vue&type=style&index=0&id=72ce11af&lang=scss&scoped=true"
import style1 from "./SimpleTableBuilderModal.vue?vue&type=style&index=1&id=72ce11af&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ce11af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ce11af')) {
      api.createRecord('72ce11af', component.options)
    } else {
      api.reload('72ce11af', component.options)
    }
    module.hot.accept("./SimpleTableBuilderModal.vue?vue&type=template&id=72ce11af&scoped=true", function () {
      api.rerender('72ce11af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/SimpleTableBuilderModal.vue"
export default component.exports